export function flattenBranches(branches) {
  if (!Array.isArray(branches) || branches.length === 0) return [];

  return branches.reduce((collectedNodes, branch) => {
    // Current branch node
    if (branch?.node) {
      collectedNodes.push(branch.node);
    }

    if (Array.isArray(branch?.linear_path)) {
      branch.linear_path.forEach((step) => {
        if (step?.node) {
          collectedNodes.push(step.node);
        }
      });
    }

    if (Array.isArray(branch?.branches) && branch.branches.length > 0) {
      collectedNodes.push(...flattenBranches(branch.branches));
    }

    return collectedNodes;
  }, []);
}

function dedupeNodesById(nodes) {
  const seenIds = new Set();
  return nodes.filter((node) => {
    if (!node || seenIds.has(node.id)) return false;
    seenIds.add(node.id);
    return true;
  });
}

export function extractNodes(stage) {
  if (!stage) return [];

  const nodes = [];

  if (stage.start_node) {
    nodes.push(stage.start_node);
  }

  if (Array.isArray(stage.linear_path)) {
    stage.linear_path.forEach((step) => {
      if (step?.node) nodes.push(step.node);
    });
  }

  if (Array.isArray(stage.branches)) {
    nodes.push(...flattenBranches(stage.branches));
  }

  return dedupeNodesById(nodes);
}

export function getWorkflowStages(workflowStages) {
  if (!Array.isArray(workflowStages)) return [];
  return workflowStages.map((stage) => ({ id: stage.id, name: stage.name }));
}

/** Finds a single stage definition by id from the cached workflow stages.*/
export function getStageById(workflowStages, stageId) {
  if (!Array.isArray(workflowStages) || stageId === null || stageId === undefined) {
    return null;
  }
  return workflowStages.find((stage) => stage.id === stageId) || null;
}

/** Returns every node available for a given stage id */
export function getNodesForStage(workflowStages, stageId) {
  const stage = getStageById(workflowStages, stageId);
  if (!stage) return [];
  return extractNodes(stage);
}

export function getNodesForStages(workflowStages, stageIds) {
  const nodes = stageIds.flatMap((stageId) => getNodesForStage(workflowStages, stageId));
  return dedupeNodesById(nodes);
}
